import globals from "@lvt/globals";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";
import qs from "qs";

import { validateRequest } from "@/api/common";
import { liveUnitsValidator } from "@/api/map/liveUnits/liveUnitSchema";
import { FilterConfig, LiveUnit } from "@/api/map/types";


export const fetchLiveUnits = createAsyncThunk("fetchLiveUnits", async (filterConfig: FilterConfig, { dispatch }) => {
    const client = applyCaseMiddleware(
        axios.create({
            baseURL: globals.userdashboard.proxyUrl,
        }),
    );

    // QS to properly format query string parameters
    client.interceptors.request.use((config) => {
        config.paramsSerializer = (params) => {
            return qs.stringify(params, {
                arrayFormat: "brackets",
                encode: false,
            });
        };

        return config;
    });

    const request = client.get("/api/vms/live_units", {
        withCredentials: true,
        params: filterConfig,
    });

    return await validateRequest<Array<LiveUnit>>(dispatch, request, liveUnitsValidator, "Failed to get live units");
});
